import { useEffect, useState } from "react";
import Layout from "../components/Layout";
import { useNavigate } from "react-router-dom";

const Users = () => {
    const [users, setUsers] = useState([]);
    const navigate = useNavigate();
    
    useEffect(() => {
        fetch("https://www.theprojectgenesis.net/api/admin/users", {
            headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` }
        })
            .then(res => res.json())
            .then(data => setUsers(data))
            .catch(err => {
                console.error(err);
            });
    }, []);

    return (
        <Layout>
            <h2>Manage Users</h2>
            <table border="1">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Role</th>
                        <th>Status</th>
                    </tr>
                </thead>
                <tbody>
                    {users.map(user => (
                        <tr key={user.id}>
                            <td>{user.id}</td>
                            <td>{user.first_name} {user.last_name}</td>
                            <td>{user.email}</td>
                            <td>{user.role}</td>
                            <td>{user.status}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </Layout>
    );
};

export default Users;
